var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavigate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "var(--button-priority)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8252 9.05361C20.523 8.8025 21.1975 9.47698 20.9464 10.1741L16.5375 22.4207C16.2637 23.182 15.1929 23.1966 14.898 22.4426L12.833 17.1664L7.55685 15.1021C6.80354 14.8072 6.81814 13.7363 7.57875 13.4619L19.8252 9.05361Z",
    fill: "var(--button-priority)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigate);
export default __webpack_public_path__ + "static/media/iconNavigate.48b6f6efc799044ada2dbf6a3e59307c.svg";
export { ForwardRef as ReactComponent };